module.exports = __webpack_public_path__ + "media/images/official/removeanxieties_voice1-61613a8291855b605e7b6973b4c677c7.png";